(function($){
    $(document).on('click', '.product-form__submit', function(){
      let form = $(this).parents('form');
      let variant_id = form.find('input.product-variant-id').val();
      let parent = $(this).parents('.product__info-container');
      let variants_json = JSON.parse(parent.find('script[type="application/json"]').html());
      let ptitle = $(this).data('product-title');
      let pvendor = $(this).data('product-vendor');
      let ptype = $(this).data('product-type');
      let pid = form.find('input[name="product-id"]').val();
      if (variant_id) {
        let variant_data = $.grep(variants_json, function( n, i ) {
          return n.id == variant_id;
        });
        if (variant_data.length != 0) {
            let dl = {
                'event': 'add_to_cart',
                'ecommerce': {
                        'currency': Shopify.currency.active,
                		'items': [{
                		'item_id': pid,
                		'item_name': ptitle,
                		'item_brand': pvendor,
                		'item_category': ptype,
                		'item_variant': variant_data[0].sku ?? '',
                		'currency': Shopify.currency.active,
                		'price': variant_data[0].price * 0.01 ?? 0
                		}]
                	}
                }
            dataLayer.push({ 'ecommerce': null });
            dataLayer.push(dl);
        }
      }
    });
})(jQuery);